// actions/items.ts — M1
import { defineAction, type Ok } from '../define';
import { g } from '../guard';
import type { ItemId } from '../../types/ids';
import type { ItemView } from '../../types/items';
import type { TileXY } from '../../types/geom';
declare module '../registry' {
  interface ActionMap {
    'item.pickUp': { req: { item: ItemId }; res: { item: ItemView } };
    'item.drop': { req: { item: ItemId; at: TileXY }; res: Ok };
    'item.move': { req: { item: ItemId; to: 'pockets' | 'storage'; slot: number | null }; res: { item: ItemView } };
  }
}
export const itemPickUp = defineAction('item.pickUp', g.obj({ item: g.id<ItemId>('i') }));
export const itemDrop = defineAction('item.drop', g.obj({ item: g.id<ItemId>('i'), at: g.tile }));
export const itemMove = defineAction('item.move', g.obj({ item: g.id<ItemId>('i'), to: g.lit('pockets', 'storage'), slot: g.nullable(g.int(0, 999)) }));
